import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsuarioAtivoService } from './../../services/usuario-ativo.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { BaseFormService } from 'src/app/services/base-form.service';
import { DadosUsuarioService } from 'src/app/services/dados-usuario.service';
import { CepPipe } from 'src/app/pipes/cep.pipe';
import { HttpResponse } from '@angular/common/http';
import { FilenameParser } from '@utils/FilenameParser';
import { FileDownloadService } from '@services/file-download.service';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { NgClass, AsyncPipe } from '@angular/common';
import { SelectComponent } from '../../components/select/select.component';
import { FieldErrorComponent } from '../../components/field-error/field-error.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';
@Component({
    selector: 'app-usuarios-ativos',
    templateUrl: './usuarios-ativos.component.html',
    styleUrls: ['./usuarios-ativos.component.scss'],
    providers: [CepPipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, FormsModule, ReactiveFormsModule, BreadcrumbComponent, PopoverDirective, NgClass, SelectComponent, FieldErrorComponent, FooterComponent, AsyncPipe, UsuarioPermissaoPipe]
})
export class UsuariosAtivosComponent implements OnInit {

  public form: UntypedFormGroup;

  public spTrans: boolean = false;
  public spTransCheck: boolean = false;

  public bolsaCredito: boolean = false;
  public enderecos: any;
  public enderecosOptions = []
  public idEmpresa: any = this.baseFormService.getIdEmpresaLocalStorage();
  public departamentos: any;
  public idEndereco: any = 0;
  public idDepartamento: any = 0;

  public ordem: any = 'N';
  public tipo: any = 'A';
  public radioButtonHtml: any = true;
  public loadingGenerico: any = false;

  constructor(private readonly dadosUsuarioService: DadosUsuarioService,
    private readonly baseFormService: BaseFormService,
    private readonly usuarioAtivoService: UsuarioAtivoService,
    private readonly cepPipe: CepPipe,
    private readonly formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.createForm();
    this.listarEnderecos();
    this.listarDepartamentos(this.idEmpresa);
  }

  private createForm() {

    this.form = this.formBuilder.group({
      enderecos: [0, []],
      idDepartamento: [0, []],
      ordem: ['N', []],
      tipo: ['A', []],
      switch: [null, []],
    });

  }

  public getAllListaUsuario(idEmpresa, spTransFlag, creditoFlag) {

    this.loadingGenerico = true;


    let departamento = this.form.value.idDepartamento;
    let endereco = this.form.value.enderecos;
    let ordem = this.form.value.ordem;
    let tipo = this.form.value.tipo;

    if (this.radioButtonHtml === true) {

        this.usuarioAtivoService
        .getRelatorioUsuarioAtivo(idEmpresa, spTransFlag, creditoFlag, endereco, departamento, ordem, tipo)
        .subscribe({
          next: ({ body, headers }: HttpResponse<any>) => {
            FileDownloadService.openContentInNewWindow(body);
          },
          error: (erro: any) => {
            console.error(erro);
            this.loadingGenerico = false;
          },
          complete: () => {
            this.loadingGenerico = false;
          }
        });
    }

    else {

       this.usuarioAtivoService
        .getRelatorioUsuarioAtivoCsv(idEmpresa, spTransFlag, creditoFlag, endereco, departamento, ordem, tipo)
        .subscribe({
          next: ({ body, headers }: HttpResponse<any>) => {
            const filename = FilenameParser.fromContentDispositionHeader(
              headers.get('content-disposition'),
              'Arquivo.pdf',
            );
            FileDownloadService.download([body], filename);
          },
          error: (erro: any) => {
            console.error(erro);
            this.loadingGenerico = false;
          },
          complete: () => {
            this.loadingGenerico = false;
          }
        });
      this.radioButtonHtml = true
    }
  }

  public baixarListaSptrans(idEmpresa, spTransFlag, creditoFlag, idEndereco, idDepartamento, ordem, tipo) {

    this.loadingGenerico = true;
    this.spTrans = true;
    this.bolsaCredito = false;

    this.usuarioAtivoService
      .getRelatorioUsuarioAtivoCsv(idEmpresa, spTransFlag, creditoFlag, idEndereco, idDepartamento, ordem, tipo)
      .subscribe({
        next: ({ body, headers }: HttpResponse<any>) => {
          const filename = FilenameParser.fromContentDispositionHeader(
            headers.get('content-disposition'),
            'Arquivo.pdf',
          );
          FileDownloadService.download([body], filename);
        },
        error: (erro: any) => {
          console.error(erro);
          this.loadingGenerico = false;
        },
        complete: () => {
          this.loadingGenerico = false;
        }
      });
  }

  hideSpTrans() {

    this.spTrans = false;
    this.bolsaCredito = false;

  }

  public isErrorField(field) {
    return (this.form.get(field).valid === false && (this.form.get(field).touched === true));
  }

  public listarEnderecos() {
    this.dadosUsuarioService.getAllEnderecos(this.idEmpresa)
    .pipe(take(1))
    .subscribe({
      next: (resposta: any) => {
        this.enderecos = resposta.response;
        this.enderecosOptions = this.enderecos.map((endereco) => {
          const part1 = [
            endereco.descricaoLogradouro,
            endereco.codigoNumero
          ]
          .map(e => (e ?? '').trim())
          .filter(Boolean)
          .join(', ');

          const cep = endereco.codigoCep ? this.cepPipe.transform(endereco.codigoCep) : '';
          const part2 = [
            endereco.codigoBairro ? `Bairro ${endereco.codigoBairro}` : '',
            endereco.codigoCidade ? `Cidade ${endereco.codigoCidade}` : '',
            endereco.codigoEstado ? `Estado ${endereco.codigoEstado}` : '',
            cep ? `CEP ${cep}` : '',
          ]
          .map(e => (e ?? '').trim())
          .filter(Boolean)
          .join(' - ');

          return {
            value: endereco.idEndereco,
            description: `${part1} ${part2}`
          };
        });
      },
      error: (error: any) => {
        console.error(error);
      }
    });

  }

  public listarDepartamentos(idEmpresa) {
    this.dadosUsuarioService.getAllDepartamentos(idEmpresa)
      .pipe(take(1))
      .subscribe({
        next: (resposta: any) => {
          this.departamentos = resposta.response;
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }
}
